import React from 'react'

const SearchIcon = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill={fill} width={width} height={height} {...props}>
    <path d='M15.03 16.09a8.25 8.25 0 1 1 1.06-1.06l6.19 6.19a.75.75 0 0 1-1.06 1.06l-6.19-6.19zm-5.28.41a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5z' />
  </svg>
)

export default SearchIcon
